//
//
//
//
//
//
//
//

import FaqAccordion from './FaqAccordion.vue';
export default {
    name: 'FaqSection',
    components: {
        FaqAccordion
    },
    props: {
        faqs: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        formattedFaqs() {
            const result = this.faqs.map((ele) => {
                return Object.keys(ele).reduce((acc, key) => {
                    switch (key) {
                        case 'question':
                            acc.heading = ele[key];
                            break;
                        case 'answer':
                            acc.body = ele[key];
                            break;
                        default:
                            acc[key] = ele[key];
                    }
                    return acc;
                }, {});
            });

            return result;
        }
    }
};
